import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

// TODO: This image rotation and sizing thing is
// hacky as hell and should ultimately be removed in
// lieu of a server side solution that actually rotates
// the image (probably when the image editing
// dashbaord and cloudinary are installed/used)
// The problem is css transform rotate does not
// update the box model and does not change its
// height, which leads to either overflow or
// adding set heights/widths.

export default class Infographic extends React.Component {
  setRef = ref => {
    this.img = ref;
    this.setState({});
  };
  render() {
    const { infographic } = this.props;
    const { heading } = infographic.image;
    const width = this.img ? this.img.clientWidth : 0;
    const height = this.img ? this.img.clientHeight : 0;
    const padding = (width - height) / 2;
    const isTall =
      (width > height && heading === 90) || (width > height && heading === 270);
    return (
      <div className="infographic">
        {infographic.name && (
          <label className="infographic-label">{infographic.name}</label>
        )}
        {infographic.image.path && (
          <div
            className="infographic-img-container"
            style={{
              paddingTop: isTall ? padding : 0,
              paddingBottom: isTall ? padding : 0
            }}
          >
            <img
              ref={this.setRef}
              src={infographic.image.path}
              alt={infographic.image.name || ''}
              className="infographic-img"
              style={{
                transform: `rotate(${infographic.image.heading}deg)`
              }}
            />
          </div>
        )}
        {infographic.content && (
          <div
            className="infographic-content"
            dangerouslySetInnerHTML={{ __html: infographic.content }}
          />
        )}
      </div>
    );
  }
}

Infographic.propTypes = {
  infographic: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Infographic/index.jsx